import { render } from "./ListDataLiburEo.vue?vue&type=template&id=13a985fa"
import script from "./ListDataLiburEo.vue?vue&type=script&lang=js"
export * from "./ListDataLiburEo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__